/**
 * Renders the [ptf_twilio_register_from_phone_form] shortcode.
 *
 * @since 3.1.0
 */

import RegisterFromPhoneForm from './components/RegisterFromPhoneForm';

import { createRoot } from '@wordpress/element';

document.addEventListener('DOMContentLoaded', () => {
	const rootNode = document.querySelector('.ptf-shortcode--ptf_twilio_register_from_phone_form');
    if ( rootNode ) {
        createRoot( rootNode ).render( <RegisterFromPhoneForm atts={ JSON.parse( rootNode.dataset?.atts || '{}' ) } /> );
    }
});
